export const reviewFeedbacksSelector = (reviewFeedbacksObj) => {
  return Object.keys(reviewFeedbacksObj)
    .map((reviewFeedbackKey) => reviewFeedbacksObj[reviewFeedbackKey]);
};
